import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByKey',
  standalone: true
})
export class FilterByKeyPipe implements PipeTransform {

  transform(value: any[], key: string, searchText: string): any[] {
    if (!value || !key || !searchText) {
      return value;
    }
    const lowerCaseSearchText = searchText.toLowerCase();
    return value.filter(item => item[key]?.toLowerCase().includes(lowerCaseSearchText));
  }

}
